import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const VatBody = styled.div`
  display: flex;
  margin: ${Spacing.S4} 0 0 0;
`

export const Footer = styled.footer`
  margin-top: auto;
  margin-bottom: -${Spacing.S8};
`
